import { graphql, useStaticQuery } from 'gatsby'

export const useOpeningHours = () => {
  const { wp } = useStaticQuery<Queries.useOpeningHoursQueryQuery>(graphql`
    query useOpeningHoursQuery {
      wp {
        acfOptionsOteviraciDoba {
          openingHours {
            days {
              dayName
              from
              to
            }
          }
        }
      }
    }
  `)

  return {
    openingHours: wp?.acfOptionsOteviraciDoba?.openingHours,
  }
}
